/**
 *  Initialize infinite scroll for blog, podcast, and press pages
 */

var infiniteScroll = (function () {
    var pub = {};

    pub.init = function () {
        $(document).ready(function () {
            $('#blog-articles').infiniteScroll({
                path: function () {
                    var skip = this.loadCount * 12;
                    return '/pages/BlogArticles?skip=' + skip + '&limit=12';
                },
                prefil: true,
                append: '.article-card-class',
                status: '.page-load-status',
                history: false
            });

            $('#podcast-articles').infiniteScroll({
                path: function () {
                    var skip = this.loadCount * 12;
                    return '/pages/PodcastArticles?skip=' + skip + '&limit=12';
                },
                prefil: true,
                append: '.article-card-class',
                status: '.page-load-status',
                history: false
            });

            $('#press-articles').infiniteScroll({
                path: function () {
                    var skip = this.loadCount * 12;
                    return '/press?skip=' + skip + '&pageSize=12';
                },
                prefil: true,
                append: '.article-card-class',
                status: '.page-load-status',
                history: false,
                fetchOptions: {
                    headers: {
                        'x-requested-with': 'XMLHttpRequest',
                    },
                },
            });

            var prize_articles = $('#prize-articles');

            prize_articles.infiniteScroll({
                path: function () {
                    var skip = this.loadCount * 12;
                    return '/articles/more/?prizeCodename=' + prize_articles.attr('codename') + '&prizeSlug=' + prize_articles.attr('slug') + '&skip=' + skip + '&pageSize=12';
                },
                prefil: true,
                append: '.article-card-class',
                status: '.page-load-status',
                history: false
            });

            setTimeout(function () {
                // Load the initial set of cards
                $('#blog-articles').infiniteScroll('loadNextPage');
                $('#podcast-articles').infiniteScroll('loadNextPage');
                $('#press-articles').infiniteScroll('loadNextPage');
                $('#prize-articles').infiniteScroll('loadNextPage');
            }, 100);
        });
    };

    return pub;
})();
